<template>
  <div class="ts-overflow-y-scroll" style="max-height: 50vh">
    <table class="ts-w-full">
      <thead>
        <tr>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">
            {{ $t('stockIn.barcode') }}
          </th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">
            {{ $t('stockIn.productName') }}
          </th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">
            {{ $t('stockIn.expireDate') }}
          </th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">
            {{ $t('stockIn.uom') }}
          </th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">
            {{ $t('stockIn.costTHB') }}
          </th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">
            {{ $t('stockIn.cost') }}
          </th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center">
            {{ $t('stockIn.qty') }}
          </th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">
            {{ $t('stockIn.discount') }}
          </th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">
            {{ $t('stockIn.discountType') }}
          </th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-right">
            {{ $t('stockIn.vatRate') }}
          </th>
          <!-- <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-right">{{ $t('stockIn.grade') }}</th> -->
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-right">
            {{ $t('stockIn.amount') }}
          </th>
          <th class="ts-text-center ts-w-1" v-if="!isNotAllowUpdate">
            <a href="#" class="ts-text-white" @click.prevent="addNewRow">
              <i class="fa fa-plus"></i>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(detail, index) in model.product_detail" :key="index">
          <td valign="top" class="ts-w-32">
            <input type="text" class="form-control" style="min-width: 90px" readonly :value="findProduct(detail.product_id)
              ? findProduct(detail.product_id).barcode
              : ''
              " />
            <!-- <a-select
              ref="barcode"
							v-model="detail.product_id" 
							class="ts-w-full"
              :class="{ 'is-invalid': errors.has('product_detail.' + index + '.product_id')}"  
							showSearch
              :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
              @change="onProductChange(detail)"
						>
              <a-select-option 
								v-for="(pro, index) in getProduct({ 
									chosenProduct: model.product_detail,
									productCurrentRow: detail.product_id
								})" 
								:key="index"
								:value="pro.product_id"
							>{{ pro.barcode }}</a-select-option>
            </a-select> -->
            <div class="invalid-feedback" v-if="errors.has('product_detail.' + index + '.product_id')">
              {{ errors.first('product_detail.' + index + '.product_id') }}
            </div>
          </td>
          <td valign="top" style="width: 300px">
            <div class="ts-flex">
              <!-- <a-select 
							v-model="detail.product_id"
							showSearch
              :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
              class="ts-w-full"
              :class="{ 'is-invalid': errors.has('product_detail.' + index + '.product_id')}"  
              @change="onProductChange(detail)"
						>
              <a-select-option
                v-for="(pro, index) in getProduct({ 
									chosenProduct: model.product_detail,
									productCurrentRow: detail.product_id
								})"
                :key="index"
								:value="pro.product_id"
              >{{ pro.product_name_en }}</a-select-option>
            </a-select> -->
              <input type="text" class="form-control" style="min-width: 300px" readonly :value="findProduct(detail.product_id)
                ? findProduct(detail.product_id).product_name_en
                : ''
                " />
              <a-popover :title="$t('stockIn.serial')" placement="bottomLeft">
                <template slot="content">
                  <div class="scroll">
                    <!-- <p><b>Total Serial: {{ detail.qty > 1 ? detail.qty : 0 }}</b></p>
                    <div style="max-width: 300px">
                      <p v-for="(s, i) in detail.imei_list" :key="i" style="width: 150px;">
                        {{ s[0] }}
                      </p>
                    </div> -->
                    <ul>
                      <b>Total Serial: {{ detail.qty > 1 ? detail.qty : 0 }}</b>
                      <div class="ts-grid ts-grid-cols-2">
                        <li v-for="(s, i) in detail.imei_list" :key="i" class="ts-px-4 ts-whitespace-no-wrap">
                          {{ s[0] }}
                        </li>
                      </div>
                    </ul>
                  </div>
                </template>
                <label
                  v-show="findProduct(detail.product_id) ? findProduct(detail.product_id).require_imei === true : false"
                  :for="'file_' + index" class="ts-border ts-px-2 ts-py-2 ts-rounded-md ts-cursor-pointer ts-h-8" :class="findProduct(detail.product_id)
                    ? 'ts-border-blue-600'
                    : ''
                    "><i class="fas fa-file-excel"></i></label>
                <input type="file" :ref="'file_' + index" :id="'file_' + index" class="ts-hidden"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="e => onFileChange(e, detail)" :class="{
                    'is-invalid': errors.has(
                      'product_detail.' + index + '.imei_list'
                    )
                  }" />
              </a-popover>
            </div>
            <div class="ts-text-red-600 ts-text-xs" v-if="errors.first('product_detail.' + index + '.imei_list')">
              {{ errors.first('product_detail.' + index + '.imei_list') }}
            </div>
          </td>
          <td valign="top" class="ts-w-48">
            <a-date-picker v-model="detail.expiry_date" :disabled="!detail.is_expire" format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY" style="min-width: 120px" class="ts-w-full" :class="{
                'is-invalid': errors.has(
                  'product_detail.' + index + '.expiry_date'
                )
              }"></a-date-picker>
            <div class="invalid-feedback" v-if="errors.has('product_detail.' + index + '.expiry_date')">
              {{ errors.first('product_detail.' + index + '.expiry_date') }}
            </div>
          </td>
          <td valign="top" class="ts-w-32">
            <a-select v-model="detail.uom_id" class="ts-w-full" style="min-width: 90px" :class="{
              'is-invalid': errors.has('product_detail.' + index + '.uom_id')
            }" :disabled="isNotAllowUpdate" @change="onUomChange(detail)">
              <a-select-option v-for="(u, index) in getUom(detail.product_id)" :key="index" :value="u.uom_id">{{
                u.uom_name_en }}
              </a-select-option>
            </a-select>
            <div class="invalid-feedback" v-if="errors.has('product_detail.' + index + '.uom_id')">
              {{ errors.first('product_detail.' + index + '.uom_id') }}
            </div>
          </td>
          <td valign="top" class="ts-w-32">
            <ts-currency-input v-model.number="detail.cost_in_bath" class="form-control ts-text-right"
              style="min-width: 100px" currency="฿" :precision="default_precision" :disabled="isNotAllowUpdate"
              @input="onThbInput(detail)" />
            <div class="validate" v-if="errors.has('product_detail.' + index + '.cost')">
              {{ errors.first('product_detail.' + index + '.cost') }}
            </div>
          </td>
          <td valign="top" class="ts-w-32">
            <ts-currency-input v-model.number="detail.cost" @keypress.enter="onCostEnter(index)"
              class="form-control ts-text-right" style="min-width: 100px" :currency="default_currency_sign"
              :precision="default_precision" :disabled="isNotAllowUpdate" @input="onUsdInput(detail)" />
            <div class="validate" v-if="errors.has('product_detail.' + index + '.cost')">
              {{ errors.first('product_detail.' + index + '.cost') }}
            </div>
          </td>
          <td valign="top" class="ts-w-24">
            <input v-model.number="detail.qty" type="number" ref="qty" @keypress.enter="onQtyEnter(index)"
              class="form-control ts-text-center" :class="{
                'is-invalid': errors.has('product_detail.' + index + '.qty')
              }" :readonly="isNotAllowUpdate" style="min-width: 80px" />
            <div class="invalid-feedback" v-if="errors.has('product_detail.' + index + '.qty')">
              {{ errors.first('product_detail.' + index + '.qty') }}
            </div>
          </td>
          <td valign="top" class="ts-w-24">
            <input ref="discountRate" v-model.number="detail.discount_rate" @keypress.enter="onDiscountRateEnter(index)"
              type="number" class="form-control" :class="{
                'is-invalid': errors.has(
                  'product_detail.' + index + '.discount_rate'
                )
              }" :readonly="isNotAllowUpdate" />
            <div class="invalid-feedback" v-if="errors.has('product_detail.' + index + '.discount_rate')">
              {{ errors.first('product_detail.' + index + '.discount_rate') }}
            </div>
          </td>
          <td valign="top" class="ts-w-24">
            <select ref="discountType" @keypress.enter="discountTypeEnter(index)" v-model="detail.discount_type"
              class="form-control" :disabled="isNotAllowUpdate">
              <option value="%">%</option>
              <option :value="default_currency_sign">
                {{ default_currency_sign }}
              </option>
            </select>
          </td>
          <td valign="top" class="ts-w-24">
            <!-- @keypress.enter="pressEnterAddNewRow(index)"   -->
            <input v-model.number="detail.vat_rate" ref="vatRate" type="number" class="form-control ts-text-right" :class="{
              'is-invalid': errors.has(
                'product_detail.' + index + '.vat_rate'
              )
            }" style="min-width: 80px" :readonly="isNotAllowUpdate" />
            <div class="invalid-feedback" v-if="errors.has('product_detail.' + index + '.vat_rate')">
              {{ errors.first('product_detail.' + index + '.vat_rate') }}
            </div>
          </td>
          <!-- <td valign="top" class="ts-w-24">
              <select class="form-control"
                v-model="detail.product_grade"
              >
                <option value="">--</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
                <option value="D">D</option>
              </select>
          </td> -->
          <td valign="top" class="ts-w-32">
            <ts-currency-input v-model="detail.total_after_discount" class="form-control ts-text-right"
              style="min-width: 120px" disabled :currency="default_currency_sign" :precision="default_precision" />
          </td>
          <td class="ts-text-center" valign="middle" v-if="!isNotAllowUpdate">
            <a href="#" class="ts-text-red-600 ts-my-auto" @click.prevent="removeRow(detail)">
              <i class="fa fa-trash"></i>
            </a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <td class="ts-text-red-700">
          <p class="ts-font-extrabold">
            {{ $t('purchaseOrder.numberRow') + ': ' }}
            <span class="ts-font-extrabold">{{
              model.product_detail.length
            }}</span>
          </p>
        </td>
        <td class="ts-text-red-700 ts-text-right ts-px-3" colspan="4">
          <p class="ts-font-extrabold">
            {{ $t('purchaseOrder.total') + ': ' }}
          </p>
        </td>
        <td class="ts-text-red-700 ts-text-right ts-px-3">
          <!-- <p class="ts-font-extrabold">{{ $defaultCurrencyWithCode(sumCost) }}</p> -->
        </td>
        <td class="ts-text-red-700 ts-text-center ts-px-3">
          <p class="ts-font-extrabold">{{ $formatNumber(sumTotalQty) }}</p>
        </td>
        <td class="ts-text-red-700 ts-text-right ts-px-3" colspan="4">
          <p class="ts-font-extrabold">
            <!-- {{ $defaultCurrencyWithCode(grandTotal, default_precision) }} -->
            {{ $defaultCurrencyWithCode(grandTotal, default_precision) }}
          </p>
        </td>
      </tfoot>
    </table>

    <!-- modal show pop-up to be able add product -->
    <a-modal v-if="show_modal_add_product" v-model="show_modal_add_product" :footer="null" :zIndex="1020"
      :maskClosable="false" width="900px" :title="$t('stockIn.product')">
      <SearchToAdd v-model="model" />
    </a-modal>
  </div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs'
import { mapGetters, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import SearchToAdd from './search-to-add.vue'

export default {
  name: 'productDetails',
  props: ['value', 'validate'],
  components: {
    SearchToAdd
  },
  data() {
    return {
      errors: new Errors(),
      show_modal_add_product: false,
      products: false,
      model: {},
      newRow: {
        product_id: null,
        uom_id: null,
        qty: 1,
        cost: 0,
        cost_in_bath: 0,
        discount_rate: 0,
        discount_type: '%',
        total_after_discount: null,
        vat_rate: 0,
        vat_amount: 0,
        grand_total: 0,
        expiry_date: null,
        is_expire: false,
        require_imei: false,
        imei_list: [],
        product_grade: ''
      }
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('stock/stockIn', ['edit_data']),
    ...mapGetters('stock/stockIn', [
      'findProduct',
      'getProduct',
      'getUom',
      'isExpirable',
      'isDefaultUom',
      'getCostPrice'
    ]),
    isNotAllowUpdate() {
      return (
        !_.isEmpty(this.edit_data) &&
        (this.edit_data ? this.edit_data.is_confirm_stock : false)
      )
    },
    grandTotal() {
      return _.sumBy(this.model.product_detail, function (o) {
        return o.grand_total
      })
    },
    sumTotalQty() {
      return _.sumBy(this.model.product_detail, 'qty')
    },
    sumCost() {
      return _.round(_.sumBy(this.model.product_detail, 'cost'), 2)
    },
    default_currency_sign() {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  methods: {
    addNewRow() {
      this.show_modal_add_product = true
      // this.model.product_detail.push(_.clone(this.newRow))
    },
    removeRow(row) {
      this.model.product_detail.splice(
        this.model.product_detail.indexOf(row),
        1
      )
    },
    onUomChange(row) {
      row.cost = this.getCostPrice({
        product_id: row.product_id,
        uom_id: row.uom_id
      })
      this.calculate()
    },
    onProductChange(row) {
      row.uom_id = this.isDefaultUom(row.product_id)
    },
    calculate() {
      this.model.product_detail.forEach(el => {
        el.cost = _.round(el.cost, this.default_precision)
        var amount = el.qty * el.cost
        var discount_amount =
          el.discount_type == '%'
            ? amount * (el.discount_rate / 100)
            : el.discount_rate
        el.vat_amount = amount * (el.vat_rate / 100)
        el.total_after_discount = amount - discount_amount
        el.grand_total = el.total_after_discount + el.vat_amount
        el.is_expire = this.isExpirable(el.product_id)
        el.require_imei = this.findProduct(el.product_id) ? this.findProduct(el.product_id).require_imei : null
      })
    },
    pressEnterAddNewRow(index) {
      if (this.model.product_detail.length == index + 1) {
        this.addNewRow()
      }
      this.$nextTick(() => {
        this.$refs.barcode[index + 1].focus()
      })
    },
    onThbInput(row) {
      row.cost = _.round(
        row.cost_in_bath / this.model.fx_bath,
        this.default_precision
      )
      this.calculate()
    },
    onUsdInput(row) {
      row.cost_in_bath = _.round(
        row.cost * this.model.fx_bath,
        this.default_precision
      )
      this.calculate()
    },
    onCostEnter(index) {
      this.$refs.qty[index].focus()
    },
    onQtyEnter(index) {
      this.$refs.discountRate[index].focus()
    },
    onDiscountRateEnter(index) {
      this.$refs.discountType[index].focus()
    },
    discountTypeEnter(index) {
      this.$refs.vatRate[index].focus()
    },
    onFileChange(e, product) {
      var file = e.target.files[0]
      var fileName = file.name
      if (fileName.endsWith('.xls') || fileName.endsWith('.xlsx')) {
        // product.label = fileName
        var reader = new FileReader()
        reader.onload = e => {
          var data = new Uint8Array(e.target.result)
          var workbook = this.readExcelData(data)

          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          product.imei_list = this.parseWorksheetData(worksheet)
          product.qty = product.imei_list.length
        }
        reader.readAsArrayBuffer(file)
        return
      }
      this.$toasted.error('Not a valid Excel file')
    },
    readExcelData(data) {
      var arr = new Array()
      for (var i = 0; i != data.length; ++i) {
        arr[i] = String.fromCharCode(data[i])
      }
      var bstr = arr.join('')
      return XLSX.read(bstr, { type: 'binary' })
    },
    parseWorksheetData(worksheet) {      
      var jsonData = []
      const range = XLSX.utils.decode_range(worksheet['!ref'])
      for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        const row = {}
        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: 0 })
          const cell = worksheet[cellAddress]

          if (cell) {
            row = cell.v
          }
        }
        if (Object.keys(row).length) {
          jsonData.push({ 0: row });
        }
      }
      return jsonData
    }
  },
  watch: {
    'model.product_detail': {
      handler() {
        this.calculate()
      },
      deep: true
    },
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

table thead tr th {
  padding: 4px 5px;
  z-index: 3;
  position: sticky;
  top: 0;
  /* Don't forget this, required for the stickiness */
  background-color: rgb(22, 102, 145);
  color: white;
}

.scroll {
  height: 200px;
  min-height: 220px;
  overflow: scroll;
}

table tbody tr td {
  padding: 4px 5px;
}

table {
  position: relative;
  border-collapse: collapse;
}
</style>
